import Tracker from './main';

export const trackerRoutes = [
  { name: 'User Events', path: '/user-events', adminOnly: true, render: () => <Tracker /> },
];